// inquire-modal.js
document.addEventListener('DOMContentLoaded', function () {
  // Insert modal HTML once
  if (!document.getElementById('inquireModal')) {
    var modalHtml = '\
    <div id="inquireModal" class="inquire-modal" aria-hidden="true">\
      <div class="modal-card" role="dialog" aria-modal="true" aria-labelledby="inquireTitle">\
        <div class="modal-header">\
          <h2 id="inquireTitle" style="margin:0;font-size:18px">Ask to inquire</h2>\
          <button class="close-btn" id="inquireClose" aria-label="Close">✕</button>\
        </div>\
        <div class="modal-body">\
          <form id="inquireForm" action="/contact" method="post">\
            <input type="hidden" name="form_type" value="contact" />\
            <input type="hidden" name="utf8" value="✓" />\
            <label for="inquireName">Your name</label>\
            <input id="inquireName" name="contact[name]" type="text" required />\
            <label for="inquireEmail">Email</label>\
            <input id="inquireEmail" name="contact[email]" type="email" required />\
            <label for="inquireMessage">Message</label>\
            <textarea id="inquireMessage" name="contact[body]" rows="5" required></textarea>\
            <div style="text-align:right;margin-top:8px">\
              <button type="submit" class="btn">Send inquiry</button>\
            </div>\
          </form>\
        </div>\
      </div>\
    </div>';
    document.body.insertAdjacentHTML('beforeend', modalHtml);
  }

  var modal = document.getElementById('inquireModal');
  var closeBtn = document.getElementById('inquireClose');
  var form = document.getElementById('inquireForm');

  function openModal(productTitle, productUrl) {
    modal.classList.add('show');
    modal.setAttribute('aria-hidden','false');
    var messageBox = document.getElementById('inquireMessage');
    if (messageBox) {
      messageBox.value = 'I am interested in: ' + productTitle + '\\nProduct link: ' + (window.location.origin + productUrl) + '\\n\\nPlease share availability/pricing.';
    }
    // optionally focus first input
    setTimeout(function(){ document.getElementById('inquireName').focus(); }, 100);
  }

  function closeModal() {
    modal.classList.remove('show');
    modal.setAttribute('aria-hidden','true');
  }

  // Open modal from any inquire button added on product page
  document.querySelectorAll('.inquire-btn').forEach(function(btn){
    btn.addEventListener('click', function(e){
      var wrapper = e.currentTarget.closest('.product-inquire-wrap') || e.currentTarget.closest('[data-product-handle]');
      var title = wrapper ? wrapper.getAttribute('data-product-title') : document.title;
      var handle = wrapper ? wrapper.getAttribute('data-product-handle') : '';
      var url = handle ? '/products/' + handle : window.location.pathname;
      openModal(title, url);
    });
  });

  // Also handle dynamically added inquire buttons (in case of theme JS re-render)
  document.body.addEventListener('click', function(e){
    if (e.target && e.target.matches && e.target.matches('.inquire-btn')) {
      var wrapper = e.target.closest('.product-inquire-wrap') || e.target.closest('[data-product-handle]');
      var title = wrapper ? wrapper.getAttribute('data-product-title') : document.title;
      var handle = wrapper ? wrapper.getAttribute('data-product-handle') : '';
      var url = handle ? '/products/' + handle : window.location.pathname;
      openModal(title, url);
    }
  });

  closeBtn && closeBtn.addEventListener('click', closeModal);
  modal && modal.addEventListener('click', function(e){
    if (e.target === modal) closeModal();
  });

  // Optional: after submit, close modal. Let Shopify handle the contact form response.
  form && form.addEventListener('submit', function(){
    // You can optionally show a loading state here
    setTimeout(closeModal, 300);
  });
});
